module.exports = __webpack_public_path__ + "static/img/8.1.0089d949.png";